<div
  class="tariff"
  *ngIf="tariff"
  data-qa="tariff"
  data-qa-button="open-tariff-description"
  (click)="openTariffDescriptionModal(tariff)"
>
  <div class="tariff-name" data-qa="tariff-name">{{ tariff.name }}</div>

  <div class="tariff-price">
    <span class="price-amount" data-qa="tariff-month-price">{{
      tariff | tariffPrice | kzCurrency
    }}</span>
    <span class="price-period" data-qa="tariff-month-period" translate>tariffs.period.MONTH</span>
  </div>

  <div class="tariff-price__year">
    <span class="price-amount" data-qa="tariff-year-price">{{
      tariff | tariffPrice: 'YEAR' | kzCurrency
    }}</span>
    <span class="price-period" data-qa="tariff-year-period" translate
      >tariffs.period.for.one.year</span
    >
  </div>

  <div class="benefit" data-qa="tariff-benefit">
    <ng-container *ngIf="tariff.benefit; else emptyLine">
      {{ 'tariffs.benefit' | translate }} – {{ tariff.benefit | kzCurrency }}
    </ng-container>
    <ng-template #emptyLine>&nbsp;</ng-template>
  </div>
</div>
